<h2 mat-dialog-title>{{ "reportTemplateDeleteConfirmDialog.confirmation" | translate }}</h2>
<ng-container>
  <div class="container" fxLayout="column" fxLayoutAlign="center center">
    <ng-container *ngIf="data.reportTemplate">
      <p>{{ "reportTemplateDeleteConfirmDialog.reportTemplateName" | translate }}</p>
      <p>
        <b>{{ data.reportTemplate.name }}</b>
      </p></ng-container
    >
    <p>{{ "reportTemplateDeleteConfirmDialog.message" | translate }}</p>
  </div>
  <div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
    <mat-dialog-actions>
      <button mat-button color="primary" mat-dialog-close>{{ "reportTemplateDeleteConfirmDialog.no" | translate }}</button>
      <button mat-raised-button color="primary" (click)="confirm()">{{ "reportTemplateDeleteConfirmDialog.yes" | translate }}</button>
    </mat-dialog-actions>
  </div>
</ng-container>
